import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DeviceBehfa_Interface } from '../../../Interface/DeviceBehfa_Interface';
import { PM_V2_Template_Interface, PM_V2_Assignment_Save_Interface } from '../../../Interface/PM_V2_Interface';
import { PM_V2_Service } from '../../../Service/PM_V2/PM_V2.service';
import { AlertifyService } from 'src/app/Service/Alertify.service';

@Component({
  selector: 'app-pm-v2-assignment-add',
  templateUrl: './PM_V2_AssignmentAdd.component.html',
  styleUrls: ['./PM_V2_AssignmentAdd.component.css']
})
export class PM_V2_AssignmentAddComponent implements OnInit {
  TemplateList: PM_V2_Template_Interface[] = [];
  SelectedDeviceBehfa: DeviceBehfa_Interface[] = [];
  Procssing = false;


  Form: FormGroup = this.fb.group({
    PM_V2_Template_ID: [null, Validators.required],
    Date_Start: ['', Validators.required]
  });

  constructor(
    private fb: FormBuilder,
    private service: PM_V2_Service,
    private Alertify_Service: AlertifyService,
    private router: Router) { }

  ngOnInit(): void {
    this.service.GetTemplateActiveList().subscribe(
      data => this.TemplateList = data || [],
      error => this.HandleError(error)
    );
  }

  SetSelectedDevice(item: DeviceBehfa_Interface) {
    if (!this.SelectedDeviceBehfa.some(x => x.id === item.id)) {
      this.SelectedDeviceBehfa.push(item);
    }
  }

  RemoveSelectedDevice(item: DeviceBehfa_Interface) {
    this.SelectedDeviceBehfa = this.SelectedDeviceBehfa.filter(x => x.id !== item.id);
  }

  Save(dateStart: string) {
    this.Form.get('Date_Start')?.setValue((dateStart || '').trim());
    if (this.Form.invalid) {
      this.Form.markAllAsTouched();
      this.Alertify_Service.ErrorMessage('Template و تاریخ شروع معتبر را مشخص کنید.');
      return;
    }
    if (this.SelectedDeviceBehfa.length === 0) {
      this.Alertify_Service.ErrorMessage('حداقل یک تجهیز را انتخاب کنید.');
      return;
    }

    const request: PM_V2_Assignment_Save_Interface = {
      PM_V2_Template_ID: Number(this.Form.get('PM_V2_Template_ID')?.value),
      DeviceBehfa_IDs: this.SelectedDeviceBehfa.map(x => x.id),
      Date_Start: this.Form.get('Date_Start')?.value
    };
    this.Procssing = true;
    this.service.AddAssignment(request).subscribe(
      result => {
        this.Procssing = false;
        if (result.CreatedCount === 0) {
          this.Alertify_Service.ErrorMessage('برای تجهیزات انتخاب‌شده قبلاً تخصیص فعال وجود دارد.');
          return;
        }
        this.router.navigate(['/pm-v2/assignment']);
      },
      error => {
        console.log(error);
        
         this.Alertify_Service.ErrorMessage(error.error.message);
      }
    );
  }

  Cancel() { this.router.navigate(['/pm-v2/assignment']); }

  private HandleError(error: any) {
    this.Procssing = false;
    this.Alertify_Service.ErrorMessage(error && error.status === 404 ? 'اطلاعات نامعتبر است یا دسترسی مجاز نیست.' : 'خطا در عملیات.');
  }
}
